import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * Medical School Debt Chart
 * Shows average medical school debt at graduation - baseline vs SAFECARE
 */
export default function MedSchoolDebtChart({ data }) {
    const chartData = data.map(year => ({
        year: year.year,
        'Baseline Debt': (year.medSchoolDebtBaseline / 1000).toFixed(1),
        'SAFECARE Debt': (year.medSchoolDebtSafecare / 1000).toFixed(1)
    }));

    return (
        <div className="chart-container">
            <h3>Medical School Debt at Graduation</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--bg-tertiary)" />
                    <XAxis
                        dataKey="year"
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                    />
                    <YAxis
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        label={{ value: 'Thousands $', angle: -90, position: 'insideLeft', fill: 'var(--text-muted)', fontSize: '11px' }}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.96)',
                            border: '1px solid var(--glass-border)',
                            borderRadius: '12px',
                            color: 'var(--text-primary)',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            fontSize: '13px'
                        }}
                        formatter={(value) => `$${value}k`}
                    />
                    <Legend
                        wrapperStyle={{ color: 'var(--text-primary)', fontSize: '12px', fontWeight: 600, paddingTop: '10px' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="Baseline Debt"
                        stroke="#ff6b6b"
                        strokeWidth={2}
                        dot={{ fill: '#ff6b6b', r: 3 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="SAFECARE Debt"
                        stroke="#a78bfa"
                        strokeWidth={2}
                        dot={{ fill: '#a78bfa', r: 3 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
